import {useDrag} from "react-dnd";

function KategorieAuswahl() {
    const [{isKategorieDragging}, dragKategorie] = useDrag(
        () => ({
            type: 'neue_kategorie',
            item: {
                type: 'neue_kategorie',
            },
            collect: (monitor) => ({
                isDragging: !!monitor.isDragging(),
            })
        }),
        []
    );

    return(
        <>
            <div className="neuesElement neueKategorie auswahllisteLine" ref={dragKategorie}><p>Neue Kategorie</p></div>
        </>
    );
}

export default KategorieAuswahl;
